import { Copy } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";

const copy = (t) => navigator.clipboard?.writeText(t).then(() => toast.success("Kopyalandı"), () => toast.error("Kopyalanamadı – elle seçip kopyalayın"));

export default function TempPasswordResult({ results, onClose }) {
  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <DialogContent aria-describedby={undefined} className="max-w-3xl" data-testid="temp-password-result">
        <DialogHeader><DialogTitle>Geçici Şifreler</DialogTitle></DialogHeader>
        <p className="text-[12px] text-amber-800 bg-amber-50 border border-amber-200 rounded p-2">Şifreler yalnızca bu ekranda <b>bir kez</b> gösterilir ve 72 saat geçerlidir. E-posta ulaşmazsa şifreyi kullanıcıya güvenli bir kanaldan iletin.</p>
        <table className="erp-table text-[12px]"><thead><tr><th>Kullanıcı</th><th>Geçici şifre</th><th>E-posta durumu</th></tr></thead>
          <tbody>{results.map((r) => (
            <tr key={r.id} data-testid={`temp-result-${r.email || r.id}`}>
              <td>{r.name}<div className="text-[11px] text-slate-400 font-mono">{r.email}</div></td>
              <td>{r.ok ? <span className="inline-flex items-center gap-1"><code className="font-mono bg-slate-100 px-1.5 py-0.5 rounded" data-testid={`temp-pw-${r.email}`}>{r.temp_password}</code>
                <Button variant="ghost" size="icon" className="h-6 w-6" onClick={() => copy(r.temp_password)} data-testid={`temp-copy-${r.email}`}><Copy className="h-3.5 w-3.5" /></Button></span> : <span className="text-rose-700">{r.error}</span>}</td>
              <td data-testid={`temp-email-status-${r.email || r.id}`}>{!r.ok ? "—" : r.email_status === "gonderildi" ? <span className="text-emerald-700">Gönderildi</span> : <span className="text-rose-700">Gönderilemedi · {r.email_error}</span>}</td>
            </tr>))}</tbody></table>
        <div className="flex justify-end"><Button onClick={onClose} data-testid="temp-result-close">Kapat</Button></div>
      </DialogContent>
    </Dialog>
  );
}
